import type { LinkType } from 'types'
import SecondaryLoginButton from '../../Login/SecondaryLoginButton'
import Button from 'content-components/_Primatives/Button'
import style from './style.scss'

type Props = {
  onClick: () => void
  commentButtonText: string
  isEmailVerified: boolean
  isLoggedIn: boolean
  loginCommentText: string
  verifyLink: LinkType
}

function ActionButton({
  onClick,
  commentButtonText,
  isEmailVerified,
  isLoggedIn,
  loginCommentText,
  verifyLink,
}: Props) {
  if (!isLoggedIn) {
    return (
      <SecondaryLoginButton className={style.wrapper} variant='primaryBlue'>
        {loginCommentText}
      </SecondaryLoginButton>
    )
  }

  if (!isEmailVerified) {
    return (
      <Button
        className={style.wrapper}
        url={verifyLink.url}
        variant='primaryBlue'
      >
        {verifyLink.text}
      </Button>
    )
  }

  return (
    <Button className={style.wrapper} variant='primaryBlue' onClick={onClick}>
      {commentButtonText}
    </Button>
  )
}

export default ActionButton
